import { useIsDesktopDevice } from '../../tools/hooks/useIsDesktopDevice.ts';
import ReportDesktopView from './desktop/Report.desktop.view.tsx';
import { Navigate, useSearchParams } from 'react-router';
import { useReportHelper } from './Report.helper.ts';
import { toast } from 'react-toastify';
import { toastOptions } from '../../tools/helpers/ToastHelper.ts';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';

export default function ReportView() {
  const isDesktop = useIsDesktopDevice();
  const [searchParams] = useSearchParams();
  const { t } = useTranslation();
  const { isReport, generateTitle, generateColumnDefByType } = useReportHelper();

  const type = searchParams.get('type');
  const report = isReport(type);

  useEffect(() => {
    if (!report) {
      toast.error(t('error.errorInvalidReport'), toastOptions);
    }
  }, [report, t]);

  if (!report) {
    return <Navigate to="/reporting" replace />;
  }

  const title = generateTitle(report);
  const columnDef = generateColumnDefByType(report);

  return (
    <>{isDesktop && <ReportDesktopView type={report} title={title} columnDef={columnDef} />}</>
  );
}
